// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lf-1";
export var messageSideRight = "_lf-2";
export var subscribeToBackInStockBubbleContainer = "_lf-0";